<template>
  <div class="page-about">
    <!-- banner -->
    <div class="section-banner section-box"></div>
    <!-- who -->
    <div class="section-who section-box">
      <div class="content-box">
        <van-collapse class="qa-list" v-model="activeNames">
          <van-collapse-item title="Who Are We?" name="1">
            <p>SURPRISE AND DELIGHT THE WORLD!</p>
            <p>
              We are the number one intelligent vending destination in
              Australia.
            </p>
            <p>
              We are the first smart vending solution in Australia and the first
              to bridge interactive new retailing environments combined with
              AIoT technology and experiential retailing to deliver the best
              surprises and joy to our customers!
            </p>
            <p>
              Lucky Box Australia is part of our AIoT Vending Umbrella including
              Sampling Vending, Trading Card Game vending and much, much more!
            </p>
          </van-collapse-item>
          <van-collapse-item title="What is Lucky Box?" name="2">
            <p>
              Lucky Box Australia produces blind mystery prizes and specifically
              designed to bring excitement, joy and spontaneous liveliness to
              all ages!
            </p>
            <p>
              Our customer focused approach and industry integrated position
              allows us to match the most diverse mystery prize pool in
              Australia and provide players a complete interactive experience
              from the moment you see our vending machines.
              <span class="go" @click="onGo"
                >Our Instagram @luckyboxaustralia</span
              >
              provides the most up to date list of prizes…hopefully we can see
              you shortly on our interactive social media!
            </p>
            <p>
              We collaborate with the largest assets in Australia and have over
              30 Lucky Box Vending Machines nationally…so get hunting and TEST
              YOUR LUCKY DAY!
            </p>
          </van-collapse-item>
          <van-collapse-item
            title="Where Can I Find Lucky Box?"
            name="3"
            @click.native="goPageByName('store')"
            class="to-store"
          >
          </van-collapse-item>
        </van-collapse>
        <!-- <p class="tips">
          We have 34 stores. Please
          <span @click="goPageByName('store')">click here</span> to see details
          location.
        </p> -->
      </div>
    </div>
  </div>
</template>
<script>
import { goPageByName } from "@/util/link";

export default {
  name: "AboutView",
  components: {},
  data() {
    return {
      activeNames: [],
    };
  },
  mounted() {
    console.log(this.$route.query);
  },
  methods: {
    goPageByName(name) {
      goPageByName({
        name,
      });
    },
    onGo() {
      window.location.href =
        "https://instagram.com/luckyboxaustralia?igshid=YmMyMTA2M2Y=";
    },
  },
};
</script>
<style lang="scss" scoped>
.page-about {
  width: 100%;
  .section-banner {
    width: 100%;
    height: 3rem;
    position: relative;
    background: url("../assets/img/about/banner.png") no-repeat center;
    background-size: 100%;
  }
  .section-who {
    width: 100%;
    padding: 0.18rem 0 0.7rem;
    background-color: #f4f5f6;
    .content-box {
      width: 100%;
      min-height: 7.19rem;
      background-image: url("../assets/img/about/bg-who-1.jpg"),
        url("../assets/img/about/bg-who-3.png"),
        url("../assets/img/about/bg-who-2.png");
      background-repeat: no-repeat, no-repeat, repeat-y;
      background-size: 100% 2.34rem, 100% 1.54rem, 100% 3.3rem;
      background-position: top center, center bottom, center 2.34rem;
    }
    .qa-list::v-deep {
      width: 5.53rem;
      padding: 2.44rem 0 0;
      margin: 0 auto;
      .van-cell {
        line-height: 1rem;
        font-size: 0.28rem;
        font-family: AlibabaPuHuiTiB;
        color: rgba(14, 14, 14, 0.85);
        padding: 0;
      }
      .van-cell::after {
        width: 100%;
        // border-top: 1px dashed #a7a7a8;
        border-bottom: none;
        right: 0;
        left: 0;
      }
      .van-collapse-item {
        border-bottom: 1px dashed #a7a7a8;
        &:first-child {
          border-top: 1px dashed #a7a7a8;
        }
      }
      .van-collapse-item::after {
        content: "";
        width: 100%;
        // border-top: 1px dashed #a7a7a8;
        position: absolute;
        bottom: 0;
        left: 0;
      }
      &.van-hairline--top-bottom::after {
        display: none;
      }
      .van-cell__right-icon {
        width: 0.22rem;
        height: 0.12rem;
        background: url("../assets/img/about/icon-arrow-b.png") no-repeat center;
        background-size: 100%;
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -0.06rem;
        transition: all 0.3s linear;
        &::before {
          content: "";
        }
      }
      .van-collapse-item__title--expanded .van-cell__right-icon {
        transform: rotate(180deg);
      }
      .van-collapse-item__content {
        text-align: left;
        font-size: 0.24rem;
        font-family: AlibabaPuHuiTiR;
        color: rgba(14, 14, 14, 0.85);
        line-height: 0.33rem;
        padding: 0.2rem 0;
        p {
          padding-top: 0.2rem;
        }
      }
      .van-collapse-item--border::after {
        display: none;
      }
      .van-cell__title {
        text-align: left;
      }
      .to-store {
        .van-collapse-item__wrapper {
          display: none;
        }
      }
      .go {
        text-decoration: underline;
        font-weight: bold;
        cursor: pointer;
        color: #ff521f;
      }
    }
    .tips {
      width: 5.53rem;
      margin: 0 auto;
      font-size: 0.24rem;
      font-family: AlibabaPuHuiTiR;
      color: rgba(14, 14, 14, 0.85);
      line-height: 0.33rem;
      padding: 0.2rem 0 1.37rem;
      span {
        color: #0099ff;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
}
</style>
